var _defs, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28 17.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#b2b2b2;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8,17.3H.8a.8.8,0,0,1-.8-.7.8.8,0,0,1,.8-.8h19a.8.8,0,0,1,.8.8A.8.8,0,0,1,19.8,17.3Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8,1.6H.8A.9.9,0,0,1,0,.8.9.9,0,0,1,.8,0h19a.9.9,0,0,1,.8.8A.9.9,0,0,1,19.8,1.6Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8,9.5H.8A.9.9,0,0,1,0,8.7a.8.8,0,0,1,.8-.8h13a.8.8,0,0,1,.8.8A.9.9,0,0,1,13.8,9.5Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3,9.5a.9.9,0,0,1-.6-.3.8.8,0,0,1,0-1.1l7-6.9a.8.8,0,0,1,1.1,1.1l-7,6.9A.5.5,0,0,1,20.3,9.5Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2,16.4l-.5-.2-7-7a.8.8,0,1,1,1.1-1.1l7,7a.8.8,0,0,1,0,1.1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.e744fad7.svg";
export { ForwardRef as ReactComponent };